/**
 * Return true if is ios user agent
 * @returns {boolean} true if is ios user agent
 */
function isIOSUserAgent() {
  return /iPad|iPhone|iPod/.test(window?.navigator?.userAgent || '');
}

/**
 * Return true if is safari desktop
 * @returns {booolean} true if is safari desktop
 */
function isSafariDesktop() {
  return (
    !isIOSUserAgent() && /AppleWebKit/.test(window?.navigator?.userAgent || '')
  );
}

module.exports = {
  isIOSUserAgent,
  isSafariDesktop,
};
